import { types, Instance, SnapshotOut } from "mobx-state-tree";
import api from "services/api/api";

const Coordinates = types.model("coordinates").props({
  coordinates: types.array(types.number),
});

const GasType = types.model("GasType").props({
  firstMetric: types.maybeNull(types.string),
  id: types.maybeNull(types.string),
  location: types.maybeNull(Coordinates),
  secondMetric: types.maybeNull(types.string),
  temperature: types.maybeNull(types.number),
  serial: types.maybeNull(types.string),
  connected: types.maybeNull(types.boolean),
  connectedDate: types.maybeNull(types.string),
  group: types.maybeNull(types.string),
});

const Location = types.model("Location").props({
  lat: types.number,
  lng: types.number,
});

export const GasModelAlarm = types
  .model("Gas")
  .props({
    alarms: types.optional(types.array(GasType), []),
    locationSelected: types.maybeNull(Location),
    idSelected: types.maybeNull(types.string),
    center: Location,
    isLoading: types.boolean,
  })
  .views((self) => ({
    filterValues(value: string | null) {
      if (value === null) return self.alarms;
      return self.alarms.filter(
        (alarm) =>
          alarm?.id?.toLowerCase().includes(value.toLowerCase()) ||
          alarm?.group?.includes(value.toLowerCase())
      );
    },
  }))
  .actions((self) => {
    function setAlarms(alarms: any) {
      self.alarms = alarms;
    }
    function setlocationSelected(cordinates: any) {
      self.locationSelected = cordinates;
    }
    function setId(id: any) {
      self.idSelected = self.idSelected === id ? null : id;
    }
    function setCenter(coordinates: any) {
      self.center = coordinates;
    }
    function setLoading(isLoading: any) {
      self.isLoading = isLoading;
    }
    return {
      setAlarms,
      setlocationSelected,
      setLoading,
      setCenter,
      setId,
    };
  })
  .actions((self) => ({
    getDevices: async () => {
      try {
        self.setLoading(true);
        const gasApi = api.gas;
        const response = await gasApi.getDevice();
        self.setAlarms(response?.devices);
        self.setCenter(response?.center);
        self.setLoading(false);
      } catch (error) {
        console.log(error);
      }
    },
  }));

type GasModelType = Instance<typeof GasModelAlarm>;
export type GasAlarm = GasModelType;
type GasSnapshotType = SnapshotOut<typeof GasModelAlarm>;
export type GasAlarmSnapshot = GasSnapshotType;
export const gasDefaultModel = () =>
  types.optional(GasModelAlarm, {
    alarms: [],
    locationSelected: null,
    idSelected: null,
    center: { lat: 0, lng: 0 },
    isLoading: false,
  });
